(function () {
    'use strict';

    angular
        .module('surveys')
        .controller('SurveysController', SurveysController);

    SurveysController.$inject = ['SurveyService', '$uibModal', '$state'];

    function SurveysController(SurveyService, $uibModal, $state) {
        var vm = this;
        vm.event_type       = $state.current.data.event_type;
        vm.getSurveys       = getSurveys;
        vm.activate         = activate;
        vm.getByFilter      = getByFilter;
        vm.mountGraph       = mountGraph;
        vm.surveySelected   = '';
        vm.title            = '';
        vm.questions        = [];
        vm.graphs           = [{title:'', answers: []}];
        vm.flag             = false;

        function activate() {
            vm.getSurveys();            
        }

        function getSurveys() {
            let query = {};
            query['event_type'] = vm.event_type;
            SurveyService.getSurveys2(query).then(function(response) {
                vm.surveys = response.data;
            }).catch(function(err) {
            });
        }

        function getByFilter() {
            vm.flag = false;

            let query = {};
            query['survey_id'] = vm.surveySelected.id;
            query['name'] = vm.surveySelected.name;
            query['event_type'] = vm.event_type;

            vm.graphs = [{title:'', answers: []}];
 
            SurveyService.getStats(query).then(function(response) {
                vm.questions = response.data.questions;
                vm.title = response.data.title;
                vm.flag= true;

                angular.forEach(vm.questions, function (question) {
                    vm.mountGraph(question);
                });

                vm.graphs = vm.graphs.filter(function(item) {
                  return item.title.length > 0;
                });
            });
        }

        function mountGraph(question) {             

            question.question = question.question.replace('%1$s', 'the event');

            var index = question.id;
            if (question.multiselect == true) {   

                vm.graphs[index] = {multiselect: false, rate: false, title:'', data: [], labels: [], colors: [], options: {
                    responsive: true,
                    plugins: {
                        datalabels: {
                            display: true, // Enable display of data labels
                            color: '#000', // Color of the data labels
                            font: {
                                weight: 'bold',
                                size: 14
                            },
                            formatter: function(value, context) {
                                return value;  // Return the value to be displayed
                            }
                        }
                    },
                    scales: {
                        yAxes: [{
                            ticks: {
                                callback: function (value) {
                                    return value;
                                },
                            }
                        }],
                    },
                    tooltips: {
                        callbacks: {
                            label: function(t, d) {
                                return t.yLabel;
                            }
                        }
                    }
                }};

                vm.graphs[index].multiselect = question.multiselect;

                if (typeof question.rate != 'undefined') {
                    vm.graphs[index].rate = question.rate.toFixed(2);
                    vm.graphs[index].stars = ((vm.graphs[index].rate/5)*100).toFixed(2);
                }

                if (typeof question.extra != 'undefined') {
                    vm.graphs[index].extra = question.extra;    
                }

                vm.graphs[index].title = question.question;            
                angular.forEach(question.answers, function (item) {
                    vm.graphs[index].data.push((item.totalLabel).toFixed(2));
                    vm.graphs[index].labels.push(item.label);
                    vm.graphs[index].colors.push('#05a9f4');
                });

            } else {
                vm.graphs[index] = {title:'', answers:[], multiselect: false};
                if (question.answers) {
                    vm.graphs[index].title = question.question;     
                    vm.graphs[index].answers = question.answers;     
                }
            }
                
        }

        vm.activate();            

    }
})();
